<button
  mat-flat-button
  [matMenuTriggerFor]="languagesMenu"
  [matTooltip]="'topbar.language' | transloco"
>
  {{ activeLang.toUpperCase() }}
</button>

<mat-menu [xPosition]="'before'" #languagesMenu="matMenu">
  @for (lang of availableLangs; track lang.id) {
    <button
      mat-menu-item
      [disabled]="lang.id === activeLang"
      (click)="setActiveLang(lang.id)"
    >
      {{ lang.label }}
    </button>
  }
</mat-menu>
